"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityOrientationListCountsDto = instanceOfFacilityOrientationListCountsDto;
exports.FacilityOrientationListCountsDtoFromJSON = FacilityOrientationListCountsDtoFromJSON;
exports.FacilityOrientationListCountsDtoFromJSONTyped = FacilityOrientationListCountsDtoFromJSONTyped;
exports.FacilityOrientationListCountsDtoToJSON = FacilityOrientationListCountsDtoToJSON;
exports.FacilityOrientationListCountsDtoToJSONTyped = FacilityOrientationListCountsDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityOrientationListCountsDto interface.
 */
function instanceOfFacilityOrientationListCountsDto(value) {
    if (!('upcoming' in value) || value['upcoming'] === undefined)
        return false;
    if (!('canceled' in value) || value['canceled'] === undefined)
        return false;
    if (!('complete' in value) || value['complete'] === undefined)
        return false;
    if (!('all' in value) || value['all'] === undefined)
        return false;
    return true;
}
function FacilityOrientationListCountsDtoFromJSON(json) {
    return FacilityOrientationListCountsDtoFromJSONTyped(json, false);
}
function FacilityOrientationListCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'upcoming': json['upcoming'],
        'canceled': json['canceled'],
        'complete': json['complete'],
        'all': json['all'],
    };
}
function FacilityOrientationListCountsDtoToJSON(json) {
    return FacilityOrientationListCountsDtoToJSONTyped(json, false);
}
function FacilityOrientationListCountsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'upcoming': value['upcoming'],
        'canceled': value['canceled'],
        'complete': value['complete'],
        'all': value['all'],
    };
}
//# sourceMappingURL=FacilityOrientationListCountsDto.js.map